import IValidateMotoristaDTO from '../entities/IValidateMotoristaDTO'
import IValidateMotoristaResponse from '../entities/IValidateMotoristaResponse'
import { ILoteRepository } from '../repositories/ILoteRepository'

export interface IValidateMotorista {
  execute(params: IValidateMotoristaDTO): Promise<IValidateMotoristaResponse>
}

export default class ValidateMotoristaImpl implements IValidateMotorista {
  constructor(private readonly lotesRepository: ILoteRepository) {}

  public async execute(
    params: IValidateMotoristaDTO,
  ): Promise<IValidateMotoristaResponse> {
    const response = await this.lotesRepository.validateMotorista(params)
    return response
  }
}
